import { WalletSecurityReminder } from './wallet-security-reminder';

export const walletSecurityReminder = new WalletSecurityReminder({
  getItem: async (key) => localStorage.getItem(key),
  setItem: async (key, value) => localStorage.setItem(key, value),
  removeItem: async (key) => localStorage.removeItem(key),
});
